import { axiosClient } from '../../../library/Service/axiosClient';

const BASE = () => `${process.env.REACT_APP_BROADCAST_SERVER}/activity-dashboard`;

export const ActivityDashboardService = {
    getGroups: () =>
        axiosClient().get(`${BASE()}/groups`),

    searchInstitutes: (search: string, groupId?: string | number) =>
        axiosClient().get(`${BASE()}/institutes`, {
            params: { search, group_id: groupId || undefined },
        }),

    getAllData: (instituteId: number, period: string, batchRange: string, r1Upper?: number, r2Upper?: number) =>
        axiosClient().get(`${BASE()}/all-data`, {
            params: { institute_id: instituteId, period, batch_range: batchRange, r1: r1Upper, r2: r2Upper },
        }),

    getSummary: (instituteId: number, period: string, batchRange: string) =>
        axiosClient().get(`${BASE()}/summary`, {
            params: { institute_id: instituteId, period, batch_range: batchRange },
        }),

    getEmailCampaigns: (instituteId: number, period: string, batchRange: string) =>
        axiosClient().get(`${BASE()}/email-campaigns`, {
            params: { institute_id: instituteId, period, batch_range: batchRange },
        }),

    // Campaign Interactions section (Email + WhatsApp) — sourced ONLY from moengage_template
    getMoengageCampaigns: (instituteId: number, period: string) =>
        axiosClient().get(`${BASE()}/moengage-campaigns`, {
            params: { institute_id: instituteId, period },
        }),

    getWhatsapp: (instituteId: number, period: string, batchRange: string) =>
        axiosClient().get(`${BASE()}/whatsapp`, {
            params: { institute_id: instituteId, period, batch_range: batchRange },
        }),

    getEvents: (instituteId: number, period: string) =>
        axiosClient().get(`${BASE()}/events`, {
            params: { institute_id: instituteId, period },
        }),

    getOtherActions: (instituteId: number, period: string, batchRange: string) =>
        axiosClient().get(`${BASE()}/other-actions`, {
            params: { institute_id: instituteId, period, batch_range: batchRange },
        }),

    getLeaderboard: (instituteId: number, period: string, batchRange: string) =>
        axiosClient().get(`${BASE()}/leaderboard`, {
            params: { institute_id: instituteId, period, batch_range: batchRange },
        }),

    getContributions: (instituteId: number, batchRange: string) =>
        axiosClient().get(`${BASE()}/contributions`, {
            params: { institute_id: instituteId, batch_range: batchRange },
        }),
};
